<template>
  <div 
    class="sm-input-tags-wrap"
    :class="{
      'error': error
    }"
  >
    <label 
      v-if="label"
      class="sm-small"
    >{{label}}</label>
    <vue-tags-input
      v-model="tag"
      :class="'sm-input-tags'"
      :tags="tags"
      :autocomplete-items="texts"
      :add-only-from-autocomplete="true"
      :placeholder="!tags.length ? placeholder : ''"
      :max-tags="maxTags || 0"
      @tags-changed="newTags => handleChange(newTags)"
      @input="handleInput"
    >
      <div
        slot="autocomplete-item"
        slot-scope="props"
        class="sm-input-tags__autocomplete"
        @click="props.performAdd(props.item)"
      >
        <span class="sm-txt-strong">Mailbox {{props.item.pmb}}</span>
        <!-- <span>{{props.item.name}}</span> -->
        <text-truncate :text="props.item.name" />
        <span
          :class="props.item.classes"
        >{{props.item.status}}</span>
      </div>
      <div 
        slot="tag-center"
        slot-scope="props"
        class="sm-input-tags__item"
        :class="{
          'active': props.tag.active
        }"
        @click="props.performOpenEdit(props.index)"
      >
        <hint-wrap 
          :text="`${props.tag.name}<span>${props.tag.status}</span>`"
          :left="true"
        >
          <template slot="content">
            <span class="sm-input-tags__item-inner">{{props.tag.text}}</span>
          </template>
        </hint-wrap>
      </div>
    </vue-tags-input>
    <span
      v-if="error" 
      class="sm-input-text-error"
    >{{error}}</span>
  </div>
</template>

<script>
import {VueTagsInput, createTag, createTags} from '@johmun/vue-tags-input';
import HintWrap from '@/components/HintWrap';
import { mapActions } from 'vuex';

export default {
  name: 'input-pmb-tags-multi',
  components: {
    'vue-tags-input': VueTagsInput,
    'hint-wrap': HintWrap
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    error: {},
    defaultTags: {},
    maxTags: {},
    preventDuplicates: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      tag: '',
      tags: [],
      availablePMBs: [],
      noUpdate: false,

      timer: 0,
      timerUpdate: 100,
      timeout: 800
    };
  },
  computed: {
    texts() {
      let res = [];

      this.availablePMBs.forEach(item => {
        res.push({
          ...item,
          text: `MAILBOX #${item.pmb}`,
          classes: this.setItemClasses(item),
          status: this.setItemStatus(item)
        });
      });

      return res;
    },
  },
  created() {
    this.timer = setInterval(() => this.timer += this.timerUpdate, this.timerUpdate);

    if (this.defaultTags && this.defaultTags.length) {
      this.createDefaultTags();
    }
  },
  methods: {
    ...mapActions({
      findPMBs: 'mail/findPMBs'
    }),
    handleInput(input) {
      if (!input)
        return;

      this.timer = 0;

      setTimeout(() => {
        if (this.timer >= this.timeout) {
          this.findPMBs(input)
            .then(res => {
              this.availablePMBs = res;
            });
        }
      }, this.timeout);
    },
    handleChange(newTags) {
      this.tags = this.preventDuplicates ? 
        (newTags.filter((v,i,a)=>a.findIndex(v2=>(v2.pmb===v.pmb))===i)) : 
        newTags;
    },
    createDefaultTags() {
      this.availablePMBs = this.defaultTags;
      
      this.tags = createTags(
        this.defaultTags.map(tag => {
          return {
            ...tag,
            text: `Mailbox #${tag.pmb}`,
            classes: this.setItemClasses(tag),
            status: this.setItemStatus(tag)
          }
        }),
        this.texts
        // [{
        //   ...this.defaultTag,
        //   text: `Mailbox #${this.defaultTag.pmb}`,
        //   classes: this.setItemClasses(this.defaultTag),
        //   status: this.setItemStatus(this.defaultTag)
        // }],
      );
    },
    setItemClasses(item) {
      let res = '';

      switch(item.inactive) {
        case 'false':
          res = 'active';
          break;
        // case '6months':
        //   res = 'inactive-6m';
        //   break;
        case 'true':
        default:
          if (/^\d+months$/.test(item.inactive)) {
                // Extract the number of months
                const numMonths = parseInt(item.inactive);
                // Generate the message dynamically
                // res = `Inactive within ${numMonths} month${numMonths > 1 ? 's' : ''}`;
                res = 'inactive-6m';
            } 
          break;
      }

      return res;
    },
    setItemStatus(item) {
      let res;

      switch(item.inactive) {
        case 'false':
          res = 'Active';
          break;
        // case '6months':
        //   res = 'Inactive within 6 month';
        //   break;
        case 'true':
          res = 'Inactive';
        default:
        if (/^\d+months$/.test(item.inactive)) {
              // Extract the number of months
              const numMonths = parseInt(item.inactive);
              // Generate the message dynamically
              res = `Inactive within ${numMonths} month${numMonths > 1 ? 's' : ''}`;
          } else {
              // Default case if the format is not recognized
              res = 'Inactive';
          }
          break;
      }

      return res;
    }
  },
  watch: {
    tags(val) {
      this.$emit('updateList', val);
    },
    defaultTags(val) {
      if (val && val.length)
        this.createDefaultTags();
    }
  }
}
</script>